import { render } from "./DogTagColor.vue?vue&type=template&id=32b2101c&scoped=true"
import script from "./DogTagColor.vue?vue&type=script&lang=js"
export * from "./DogTagColor.vue?vue&type=script&lang=js"

import "./DogTagColor.vue?vue&type=style&index=0&id=32b2101c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b2101c"]])

export default __exports__